import { render, staticRenderFns } from "./bindForm.vue?vue&type=template&id=20d38ec4&scoped=true"
import script from "./bindForm.vue?vue&type=script&lang=js"
export * from "./bindForm.vue?vue&type=script&lang=js"
import style0 from "./bindForm.vue?vue&type=style&index=0&id=20d38ec4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d38ec4",
  null
  
)

export default component.exports